import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';

import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { FileInfo, FileUploadError, FileUploadStatus } from '@vendasta/galaxy/uploader';

import { EmailPreviewRefreshService } from '../../services/email-preview-refresh.service';

// Interface
export interface ContactCard {
  contactPhoto: string;
  size: 'small' | 'medium' | 'large';
  contactName: string;
  jobTitle: string;
  additionalInfo: string[];
}

// Default blank value
export const blankContactCardBlock: ContactCard = {
  contactPhoto: null,
  size: 'large',
  contactName: null,
  jobTitle: null,
  additionalInfo: [''],
};

@Component({
  selector: 'email-contact-card',
  templateUrl: './contact-card.component.html',
  styleUrls: ['./contact-card.component.scss'],
})
export class ContactCardComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'email-contact-card-block';
  @Input() content: ContactCard;
  @ViewChild('blockInputs') blockInputs: NgForm;

  @Output() isBlockValid = new EventEmitter<boolean>();

  FileUploadStatus = FileUploadStatus;
  private readonly subscriptions: Subscription[] = [];

  constructor(private emailPreview: EmailPreviewRefreshService, private readonly alerts: SnackbarService) {}

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.blockInputs.form.valueChanges.subscribe(() => {
        this.emailPreview.refresh();
      }),
      this.blockInputs.statusChanges.subscribe((status) => {
        this.isBlockValid.emit(status === 'VALID');
      }),
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fixFieldLosingFocusWhenTyping(index: any, item: any): any {
    // https://stackoverflow.com/a/60945501/7338673
    return index;
  }

  clearImage(): void {
    this.content.contactPhoto = null;
    this.emailPreview.refresh();
  }

  setImage(file: FileInfo): void {
    this.content.contactPhoto = file.url;
    this.emailPreview.refresh();
  }

  alertFileErrored($event: FileUploadError): void {
    console.error('Image upload failed', $event);
    this.alerts.openErrorSnack('IMAGE_UPLOAD_FAILURE');
  }

  addAdditionalItem(): void {
    this.content.additionalInfo.push('');
  }
  removeAdditionalItem(index: number): void {
    this.content.additionalInfo.splice(index, 1);
  }
}
